import { supabase } from '../supabase';
import {
  montarTimeline,
  type ItemAtividade,
  type ComentarioProjetoBruto,
  type ComentarioTarefaBruto,
  type EventoStatusBruto,
} from './timeline';
import { comentarioApagado, TEXTO_COMENTARIO_APAGADO } from '../comentarioApagado';

/**
 * As três consultas da timeline do projeto (mural, comentários e mudanças de status das tarefas).
 * Compartilhada entre a aba Atividade e o resumo "Atividade recente" da Visão Geral, para as duas
 * nunca divergirem sobre o que conta como atividade.
 */
export const carregarAtividadeProjeto = async (
  projetoId: number,
  idsTarefa: (number | string)[],
  titulosDeTarefa: Map<string, string>,
): Promise<ItemAtividade[]> => {
  const [muralRes, comentRes, eventosRes] = await Promise.all([
    supabase.from('comentarios_projetos').select('*').eq('projeto_id', projetoId),
    idsTarefa.length
      ? supabase.from('comentarios_tarefas').select('*').in('tarefa_id', idsTarefa)
      : Promise.resolve({ data: [] as ComentarioTarefaBruto[] }),
    idsTarefa.length
      ? supabase.from('tarefa_status_events').select('*').in('tarefa_id', idsTarefa)
      : Promise.resolve({ data: [] as EventoStatusBruto[] }),
  ]);

  return montarTimeline({
    comentariosProjeto: (muralRes.data || []) as ComentarioProjetoBruto[],
    // #6287: comentário apagado aparece como tal, sem texto nem imagem.
    comentariosTarefas: ((comentRes.data || []) as (ComentarioTarefaBruto & { apagado_em?: string | null })[])
      .map(c => comentarioApagado(c) ? { ...c, conteudo: TEXTO_COMENTARIO_APAGADO, anexos_url: [] } : c),
    eventosStatus: (eventosRes.data || []) as EventoStatusBruto[],
    titulosDeTarefa,
  });
};
